export const quote = {
  title: "Liste des devis",
  quoteNumber: "Numéro devis",
  quoteRef: "Référence devis",
  quote_num: "Numéro de devis",
  client: "Client",
  client_name: "Nom du client",
  startDate: "Date de début",
  start_date: "Date de début",
  issueDate_label: "Date d’émission du devis",
  validityPeriod_label: "Durée de validité de l’offre",
  estimatedDuration_label: "Durée estimée de la prestation",
  amountHT: "Montant HT (€)",
  tva: "TVA (%)",
  amountTTC: "Montant TTC (€)",
  status: "Statut",
  status_all: "Tous les statuts",
  "status.pending": "En attente",
  "status.accepted": "Accepté",
  "status.refused": "Refusé",
  "status.invoiced": "Facturé",
  "status.all": "Tous",

  validity: "Validité (jours)",
  dueDate: "Date d'échéance",
  paymentDeadline: "Délai de paiement",
  actions: "Actions",
  edit: "Modifier",
  view: "Consulter",
  editQuote: "Modifier le devis",
  cancel: "Annuler",
  save: "Enregistrer",
  create_btn: "Créer un devis",
  new_quote: "Créer un nouveau devis",
  finalize: "Confirmer",
  success_created: "Devis créé avec succès",
  errorExists: "Le numéro de devis existe déjà.",
  errorEdit: "Erreur lors de la modification.",
  all_clients: "Tous les clients",
  date_placeholder: "jj/mm/aaaa",
  details_quote: "Détails de devis",
  error_add_offers: "Ajouter les offres à votre devis",
  consult: "Consulter",
  number: "Numéro devis",
  preview: "Devis",
  startDate_label: "Date de début",
  days: "jours",
  estimatedDuration: "Durée estimée",
  validityPeriod: "Durée de validité",
  issueDate: "Date d’émission",

  empty_title: "Créez un devis",
  empty_description:
    "Créez et envoyez vos devis à vos clients en toute simplicité",
  create_button: "Créer un devis",
  error_message_bank:
    " Vous devez ajouter vos coordonnées bancaires avant de créer une facture.",
  add_now: "Ajouter maintenant",
};
